/**
 * All available routes for the app
 */

export const HOME = '/';

export const FORGOT_PASSWORD = '/forgot-password';

export const RESET_PASSWORD = '/reset-password';

export const USER_PROFILE = '/:username';

export const EXPLORE = '/explore';

export const PEOPLE = '/people';

export const SCHEDULES = '/schedules';

export const SCHEDULE = '/schedule/:id';

export const NOTIFICATIONS = '/notifications';

export const MESSAGES = '/messages/:userId';

export const MESSAGES_CALL = '/messages/:userId/:roomId';

export const POST = '/post/:id';

export const ROOM = '/room/:roomId/:userId?';

export const SPEEDNETWORKING = '/speed-networking';

export const ADMINISTRATION = '/administration/tickets';

/**
 * Value that's used in place of id when creating something new.
 */
export const NEW_ID_VALUE = 'new';
